import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getUserMenuList } from "../../../../application/selectors/user";
import Dashboard from "../../../components/dashboard";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";

const MenuPage = () => {
  const [menu, setMenu] = useState({ title: "sdkfjskdljfklsd", children: [] });
  const menuList = useSelector(getUserMenuList);

  useEffect(() => {
    if (menuList && Array.isArray(menuList)) {
      const item = menuList.find((x) => x.link === "/MNG");
      if (item) {
        setMenu(item);
      }
    }
  }, [menuList]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Dashboard menuList={menu.child} cartTitle={menu.title} />
      </Grid>
    </Grid>
  );
};

export default MenuPage;
